import React from "react";
import { connect } from "react-redux";
import "../css/empowering.css";

const Empowering = ({ empoweringData }) => {
  if (!empoweringData) return null;

  return (
    <div className="empowering-container" style={{ backgroundColor: "#86229e" }}>
      <div className="empowering-inner">

        {/* LEFT SIDE TEXT */}
        <div className="empowering-text fade-in">
          <h1 className="titlee">{empoweringData.heading}</h1>
          <p className="subtitle">{empoweringData.paragraph}</p>

          <div className="case-studies">
            {empoweringData.case_studies.map((study, index) => (
              <div className="case-study" key={index}>
                <h3 className="twopara">{study.title}</h3>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT SIDE IMAGE */}
        <div className="empowering-image-wrapper">
          <img
            src={empoweringData.banner_image}
            alt="Empowering Visual"
            className="empowering-image"
          />
        </div>

      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  empoweringData: state.empowering.data || null,
});

export default connect(mapStateToProps)(Empowering);
